<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
  >
    <ng-container matColumnDef="name"
                  sticky
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Name
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem] md:w-[30rem] md:min-w-[30rem]"
          mat-cell>
          <span
            (click)="eachRow.status.key > userStatusMap.inProcess ?
             openUserDetails(eachRow) : {}"
            [class.clickable]="eachRow.status?.key > userStatusMap.inProcess"
          >
            {{ eachRow.firstName }} {{ eachRow.lastName }}
          </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="pronouns"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Preference
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.preferredPronouns?.value }}
      </td>
    </ng-container>
    <ng-container matColumnDef="role"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Role
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ typeMap[eachRow.role?.key] }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Status
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color':
            userStatusColors[eachRow.status?.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow.status?.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="participantsGroupStatus">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Participant Group Status
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color':
            participantGroupStatusColors[eachRow?.participantsGroupStatus?.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow?.participantsGroupStatus?.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--      Phone Number-->
    <ng-container
      matColumnDef="phoneNumber"
    >
      <th
        *matHeaderCellDef
        id="phoneNumber"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Phone Number
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.phoneNumber }}
      </td>
    </ng-container>
    <!--      Email-->
    <ng-container
      matColumnDef="email"
    >
      <th
        *matHeaderCellDef
        id="email"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Email ID
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.emailId }}
      </td>
    </ng-container>
    <ng-container matColumnDef="gender"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Gender
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.gender?.value }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ageAtStart"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Age at Start
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        {{ eachRow.ageAtStart }}
      </td>
    </ng-container>
    <ng-container matColumnDef="mostRecentAttendedSession"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Most Recent Session Attended
      </th>
      <td (click)="eachRow.mostRecentAttendedSession ? sessionNameClick(eachRow):''"
          *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
          <span
            [class.clickable]="eachRow.mostRecentAttendedSession"
          >
            {{
              eachRow.mostRecentAttendedSession ? 'Session ' +
                eachRow.mostRecentAttendedSession : ''
            }}
          </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="totalAttendance"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Total Attendance
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <ng-container *ngIf="eachRow.totalSessionsConducted; else noData">
          {{ eachRow.totalAttendedSessions }}
          / {{ eachRow.totalSessionsConducted }}
        </ng-container>
        <ng-template #noData>

        </ng-template>
      </td>
    </ng-container>
    <!--      Ethnicity-->
    <ng-container
      matColumnDef="ethnicity"
    >
      <th
        *matHeaderCellDef
        id="ethnicity"
        mat-header-cell
      >
        <div>
          Ethnicity
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.ethnicity }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Preferred Language-->
    <ng-container
      matColumnDef="preferredLanguage"
    >
      <th
        *matHeaderCellDef
        id="preferredLanguage"
        mat-header-cell
      >
        <div>
          Preferred Language
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.preferredLanguage }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Race-->
    <ng-container
      matColumnDef="race"
    >
      <th
        *matHeaderCellDef
        id="race"
        mat-header-cell
      >
        <div>
          Race
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.race }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Govt Assist-->
    <ng-container
      matColumnDef="govtAssist"
    >
      <th
        *matHeaderCellDef
        id="govtAssist"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Govt Assistance
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.govtAssist }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Snap-->
    <ng-container
      matColumnDef="snap"
    >
      <th
        *matHeaderCellDef
        id="snap"
        mat-header-cell
      >
        <div>
          SNAP
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.snap }}
        </ng-container>
      </td>
    </ng-container>
    <!--      schoolLunchProgram-->
    <ng-container
      matColumnDef="schoolLunchProgram"
    >
      <th
        *matHeaderCellDef
        id="schoolLunchProgram"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          School Lunch Program
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.schoolLunchProgram }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Food Insecurity-->
    <ng-container
      matColumnDef="foodInsecurity"
    >
      <th
        *matHeaderCellDef
        id="foodInsecurity"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Food Insecurity
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.foodInsecurity }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Housing Insecurity-->
    <ng-container
      matColumnDef="housingInsecurity"
    >
      <th
        *matHeaderCellDef
        id="housingInsecurity"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Housing Insecurity
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.housingInsecurity }}
        </ng-container>
      </td>
    </ng-container>
    <!--      Financial Strain-->
    <ng-container
      matColumnDef="financialStrain"
    >
      <th
        *matHeaderCellDef
        id="financialStrain"
        mat-header-cell
      >
        <div
          class="pl-[12px]"
        >
          Financial Strain
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem]"
          mat-cell>
        <ng-container>
          {{ eachRow.financialStrain }}
        </ng-container>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
